import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CountryISO } from '@home365/home365-phone-form';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Observable, of, takeUntil, take, map, catchError } from 'rxjs';
import { SharedService } from '../../../shared/services/shared.service';
import { RequestService } from '../../../shared/services/request.service';
import { StorgeService } from '../../../shared/services/storge.service';
import { requestUser } from '../../../shared/classes';

const EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

@Component({
  selector: 'contactForm',
  templateUrl: './contactForm.component.html',
  styleUrls: ['./contactForm.component.scss']
})
export class ContactFormComponent implements OnInit,OnDestroy {
  form!: FormGroup;
  private _destroy$ = new Subject();
  disabledPhone: boolean = false;
  validate: Observable<any> = of(null);
  defaultCountry = CountryISO.UnitedStates;
  phoneInputLabel: string = '';
  _phoneData: any;
  phone: any;
  @Output() phontDetails = new EventEmitter<any>()
  loading: boolean = false;
  isMobile: boolean = false;
  requestUser!: requestUser;
  @Output() contactForm = new EventEmitter<any>()

  constructor(
    private fb: FormBuilder,
    private requestService: RequestService,
    private sharedService: SharedService,
    private translate: TranslateService,
    private storgeService: StorgeService
  ) { }

  ngOnInit() {
    
    this.isMobile = this.sharedService.isMobile;
    this.initForm();
    this.sharedService.changeMessage({ action: 'loading', actionData: false })
    this.form?.valueChanges.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.sharedService.changeMessage({ action: 'valid', isValid: this.form.valid })
    })

  }

  ngOnDestroy() {
    this._destroy$.next(null);
    this._destroy$.complete();
  }


  initForm() {
    this.form = this.fb.group({
      firstName: this.fb.control(null,[Validators.required]),
      lastName: this.fb.control(null,[Validators.required]),
      email: this.fb.control(null, [
        Validators.email,
        Validators.pattern(EMAIL),
        Validators.required
      ]),
      fullPhone: this.fb.control(null, [Validators.required])
    });
    this.contactForm.emit(this.form)
    this.requestUser = this.storgeService.getFromStorge('requestUser')
    if(this.requestUser) {
      this.form.patchValue({
        firstName: this.requestUser.name ? this.requestUser.name.split(" ")[0] : this.requestUser.firstName,
        lastName: this.requestUser.name ? this.requestUser.name.split(" ")[1] : this.requestUser.lastName,
        email: this.requestUser.email,
        fullPhone: this.requestUser.phoneNumber,
      })
      // this._phoneData = this.requestUser.phoneData
      this.phone = {
        code: this.requestUser.phoneData.phonePrefix,
        phone: this.requestUser.phoneData.phoneNumber,
        fullPhone: this.requestUser.phoneData.fullPhone,
      }
    }
  }

  get firstName() {
    return this.form.get('firstName') as FormControl;
  }
  get lastName() {
    return this.form.get('lastName') as FormControl;
  }
  get email() {
    return this.form.get('email') as FormControl;
  }
  get fullPhone() {
    return this.form.get('fullPhone') as FormControl;
  }

  onPhoneChanged(event: any) {
    if(event && event.phoneNumber) {
      this._phoneData = event;
      this.phontDetails.emit(this._phoneData)
      this.fullPhone.setValue(event?.fullPhone)
    }
    else {
      this.fullPhone.setValue(null)
    }
  }
  

}
